















import moment from 'moment-timezone'
import { Vue, Component, Prop, Watch } from 'vue-property-decorator'
import { State, Action, Getter } from 'vuex-class'
import { RootState } from '@/store/types'
import { EditorEntry } from '@/store/editor/types'
import { REVISION_LOAD_INITIAL } from '@/store/revision/constants'
import API from '@/util/api/API'

const RevisionList = () => import('./RevisionList.vue')

@Component({ components: { RevisionList }, name: 'revision-panel' })
export default class RevisionPanel extends Vue {
    @Prop({ type: Boolean, default: true })
    collapsed!: boolean

    /**
     * If the initial list of revisions has been loaded
     */
    hasLoaded: boolean = false

    @Action(REVISION_LOAD_INITIAL)
    loadInitialRevisions!: () => Promise<void>

    @Watch('collapsed')
    onToggle(collapsed: boolean): void {
        if (!collapsed) {
            this.tryLoad()
        }
    }

    /**
     * Load the initial revisions
     */
    tryLoad(): void {
        API.whenConnected(() => {
            if (!this.hasLoaded) {
                this.loadInitialRevisions()
                this.hasLoaded = true
            }
        })
    }
}
